import { PASSWORD_RULES } from "@/lib/password";
import { Check, X } from "lucide-react";

// Live checklist that mirrors the backend's M-5 password policy so users see
// exactly why a password will be accepted or rejected before they submit.
export default function PasswordChecklist({ password }) {
  const pw = password || "";
  return (
    <ul className="mt-2 space-y-1 text-xs" data-testid="password-checklist">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(pw);
        return (
          <li
            key={r.key}
            className={ok ? "flex items-center gap-2 text-emerald-600" : "flex items-center gap-2 text-slate-500"}
            data-testid={`pw-rule-${r.key}-${ok ? "ok" : "todo"}`}
          >
            {ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}
            <span>{r.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
